import { Button, List, Modal, Typography } from "antd"

import { FiatWithdrawalResponse } from "@src/shared/api/generated"
import { dateTimeFormat } from "@src/shared/date"
import css from "./index.module.css"

type Props = {
  info: FiatWithdrawalResponse
  onCancel: () => void
  onSubmit: () => void
  open: boolean
}
const { Title } = Typography

const { Item: ListItem } = List

export const WithdrawalInfo = ({ info, onCancel, onSubmit, open }: Props) => {
  return (
    <Modal closable={false} footer={null} open={open}>
      <div className={css.modal}>
        <Title level={4} style={{ margin: 0 }}>
          Withdrawal information
        </Title>
        <List className={css.infoList}>
          <ListItem>
            <div>ID:</div>
            <div className={css.listValue}>{info?.id}</div>
          </ListItem>
          <ListItem>
            <div>Date:</div>
            {info?.created_at && (
              <div className={css.listValue}>
                {dateTimeFormat(info?.created_at as string)}
              </div>
            )}
          </ListItem>
          <ListItem>
            <div>Amount:</div>
            <div className={css.listValue}>
              {info?.amount} {info?.bank_account_currency}
            </div>
          </ListItem>
          <ListItem>
            <div>Total amount:</div>
            <div className={css.listValue}>
              {info?.total_amount} {info?.bank_account_currency}
            </div>
          </ListItem>
          <ListItem>
            <div>Status:</div>
            <div className={css.listValue}>{info?.status}</div>
          </ListItem>
          <ListItem>
            <div>Account Name:</div>
            <div className={css.listValue}>
              {info?.bank_account_details?.beneficiary_account_name}
            </div>
          </ListItem>
          <ListItem>
            <div>IBAN:</div>
            <div className={css.listValue}>
              {info?.bank_account_details?.beneficiary_account_number}
            </div>
          </ListItem>
          <ListItem>
            <div>BIC:</div>
            <div className={css.listValue}>
              {info?.bank_account_details?.bic_swift_code}
            </div>
          </ListItem>
          <ListItem>
            <div>Bank Name:</div>
            <div className={css.listValue}>
              {info?.bank_account_details?.bank_name}
            </div>
          </ListItem>
          <ListItem>
            <div>Bank Address:</div>
            <div className={css.listValue}>
              {info?.bank_account_details?.beneficiary_address}
            </div>
          </ListItem>
        </List>
        <div className={css.buttonsWrapper}>
          <Button
            className={css.button}
            id="GENERATED_ID_WITHDRAWALINFO_BUTTON_CANCEL_1"
            onClick={onCancel}
            size="large"
          >
            Cancel
          </Button>

          <Button
            id="GENERATED_ID_WITHDRAWALINFO_BUTTON_APPROVE_1"
            onClick={onSubmit}
            size="large"
            type="primary"
          >
            Approve
          </Button>
        </div>
      </div>
    </Modal>
  )
}
